<template>
  <div class="product">
    <v-flex lg8 md8 xl8 xs12 sm12>
      <v-card>
        <v-toolbar flat color="white">
          <v-toolbar-title>
            <span style="color:#0cabc2">All Vegetables</span>
          </v-toolbar-title>
          <v-dialog v-model="dialog" max-width="500px">
            <v-btn slot="activator" color="primary" dark class="mb-2">New Vege</v-btn>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm12 md12 xl12>
                      <v-text-field v-model="edit_name" label="Vege Name"></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 md12 xl12>
                      <v-text-field v-model="edit_product_code" label="Item Code"></v-text-field>
                    </v-flex>

                    <v-flex xs12 sm12 md12 xl12>
                      <!-- <v-checkbox v-model="editedItem.sewa" unchecked value label="Sewa"></v-checkbox>
                      -->
                      <p>
                        <input type="checkbox" name="cb" id="cb1" v-model="edit_sewa" />
                        <label for="cb1">Sewa?</label>
                      </p>
                    </v-flex>

                    <v-flex xs12 sm12 md12 xl12>
                      <!-- <v-text-field v-model="editedItem.type" label="type"></v-text-field> -->
                      <v-select
                        item-text="type"
                        item-value="type"
                        :items="typeList"
                        v-model="edit_type"
                        label="Basket Type"
                        persistent-hint
                        single-line
                      ></v-select>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 md12 xl12>
                      <v-text-field
                        type="number"
                        step="0.01"
                        v-model="editedItem.price"
                        label="Price(RM)"
                      ></v-text-field>
                    </v-flex>-->
                    <v-flex xs12 sm12 md12 lg12 xl12>
                      <img :src="imageUrl" height="150" v-if="imageUrl" />
                      <v-text-field
                        label="Select Image"
                        @click="pickFile"
                        v-model="imageName"
                        prepend-icon="attach_file"
                        readonly
                      ></v-text-field>
                      <input
                        type="file"
                        style="display: none"
                        ref="image"
                        accept="image/*"
                        @change="onFilePicked"
                      />
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" flat @click="close">Cancel</v-btn>
                <v-btn color="primary" flat @click.native="save">Save</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>

        <v-toolbar card color="white">
          <v-text-field
            flat
            solo
            prepend-icon="search"
            placeholder="Search Vege"
            v-model="search"
            hide-details
            class="hidden-sm-and-down"
          ></v-text-field>
        </v-toolbar>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <p v-if="errors.length">
            <v-alert :value="true" color="error" type="error" dismissible outline>{{ errors }}</v-alert>
          </p>
          <v-data-table
            :headers="headers"
            :items="desserts"
            :search="search"
            class="elevation-1"
            disable-initial-sort
          >
            <template slot="items" slot-scope="props">
              <tr
                :style="{backgroundColor: (props.item.status == '1' ? '#f4424226' : '#ffffff' ) }"
              >
                <!-- <td>
                <v-avatar size="32">
                   <img :src="props.item.avatar" alt> 
                  <img :src="require('./assets/image/'+ props.item.image)">
                </v-avatar>
                </td>-->
                <td>
                  <v-avatar size="38">
                    <img :src="(baseUrl+'/product/vege_img/'+props.item.picture)" />
                  </v-avatar>
                </td>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.type }}</td>
                <td>{{ props.item.product_code }}</td>
                <td>{{ (props.item.sewa == '1'? 'yes' :'no') }}</td>

                <!-- <td>{{ props.item.price }}</td> -->

                <td class="justify-end layout px-2">
                  <v-btn
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="primary"
                    @click="editItem(props.item)"
                    small
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <v-btn depressed outline icon fab dark color="primary" small>
                    <v-icon @click="deleteItem(props.item)">delete</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <v-alert :value="true" color="primary" icon="warning">No data :(</v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="primary"
              icon="warning"
            >Your search for "{{ search }}" found no results.</v-alert>
          </v-data-table>
          <v-spacer></v-spacer>
        </v-card-text>
      </v-card>
    </v-flex>
    <v-snackbar v-model="snackbar" :top="true" :timeout="10000">
      No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>
<script>
import axios from "axios";
// import UploadButton from "vuetify-upload-button";
import baseUrl from "@/api/baseurl";

export default {
  data: () => ({
    components: {
      //   "upload-btn": UploadButton
    },
    search: "",
    imageName: "",
    imageUrl: "",
    dialog: false,
    baseUrl: baseUrl,

    snackbar: false,
    selected: [],
    errors: "",
    headers: [
      {
        text: "Vege Image",
        value: "image",
        sortable: false
      },

      { text: "Name", value: "name" },
      { text: "Type", value: "type" },
      { text: "Item Code", value: "product_code" },
      { text: "Sewa", value: "sewa" },
      { text: "Actions", align: "right", value: "id", sortable: false }
    ],
    desserts: [],
    typeList: [{ type: "basket" }, { type: "non-basket" }, { type: "box" },{ type: "pcs" },{ type: "bag" },{ type: "pkt" }],
    editedIndex: -1,
    editedItem: {
      name: "",
      image: ""
    },
    defaultItem: {
      name: "",
      image: ""
    },
    edit_id:"",
    edit_name: "",
    edit_product_code: "",
    edit_sewa: "",
    edit_type: ""
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Vege" : "Edit Vege";
    },
    
  },

  watch: {
    dialog(val) {
      val || this.close();
    }
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const params = new URLSearchParams();
      params.append("getAllProduct", "product");

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/product/product.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.desserts = response.data.data;
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    },

    editItem(item) {
      this.imageName = "";
      this.imageFile = "";
      this.imageUrl = "";
      this.editedIndex = this.desserts.indexOf(item);
      // this.editedItem = Object.assign({}, item);
      this.edit_id = item.id;
      this.edit_name = item.name;
      this.edit_product_code = item.product_code;
      this.edit_sewa = item.sewa;

      if(this.edit_sewa=='1'){this.edit_sewa=true;}else{this.edit_sewa=false}
      this.edit_type = item.type;
      this.dialog = true;
    },

    deleteItem(item) {
      //  const index = this.desserts.indexOf(item);
      var id = item.id;
      var status = item.status;

      const params = new URLSearchParams();
      params.append("product_id", id);
      params.append("status", status);
      params.append("delete_product", "product");

      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/product/product.php",
        data: params
      }).then(response => {
        if (response.data.error == false) {
          this.initialize();
          // const index = this.desserts.indexOf(item);
          // this.desserts.splice(index, 1);
        } else if (response.data.error == true) {
          this.errors = response.data.message;
          setTimeout(
            function() {
              this.errors = "";
            }.bind(this),
            6000
          );
        }
        this.initialize();
      });
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },

    save() {
      if (this.editedIndex > -1) {
        var id = this.edit_id;

        const params = new URLSearchParams();

        params.append("update_product", "update_product");
        params.append("product_id", id);
        params.append("name", this.edit_name);
        params.append("type", this.edit_type);
        params.append("product_code", this.edit_product_code);
        params.append("sewa", (this.edit_sewa==true?'1':'0'));
        params.append("price", "0");
        params.append("image", this.imageUrl);
        params.append("image_name", this.imageName);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/product/product.php",
          data: params
        }).then(response => {
          if (response.data.error == false) {
            this.initialize();
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
          this.initialize();
        });
      } else {
        const params = new URLSearchParams();
        params.append("create_product", "product");
        params.append("name", this.edit_name);
        params.append("type", this.edit_type);
        params.append("product_code", this.edit_product_code);
        params.append("sewa", (this.edit_sewa==true?'1':'0'));

        params.append("price", "0");
        params.append("image", this.imageUrl);
        params.append("image_name", this.imageName);

        axios({
          method: "post",
          url: baseUrl + "/vege_web_v2/product/product.php",
          data: params
        }).then(response => {
          if (response.data.error == false) {
            this.initialize();
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            setTimeout(
              function() {
                this.errors = "";
              }.bind(this),
              6000
            );
          }
          this.initialize();
        });
      }
      this.close();
    },
    pickFile() {
      this.$refs.image.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.imageName = files[0].name;

        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.imageUrl = fr.result;
          this.imageFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.imageName = "";
        this.imageFile = "";
        this.imageUrl = "";
      }
    }
  }
};
</script>
<style scoped>
body {
  background: #2c3e50;
}
/* Basic styles */
input[type="checkbox"],
input[type="radio"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
label {
  position: relative;
  display: inline-block;
  padding: 0 0 0 2em;
  height: 1.5em;
  line-height: 1.5;
  cursor: pointer;
}
label::before,
label::after {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 1.5em;
  height: 1.5em;
}
label::before {
  content: " ";
  border: 2px solid #bdc3c7;
  border-radius: 20%;
}
/* Checkbox */
input[type="checkbox"] + label::after {
  content: "\2714";
  color: #2c3e50;
  line-height: 1.5;
  text-align: center;
}
/* Radio */
input[type="radio"] + label::before {
  border-radius: 50%;
}
input[type="radio"] + label::after {
  content: " ";
  top: 0.25em;
  left: 0.25em;
  width: 1em;
  height: 1em;
  background: #fff;
  border: 0.2em solid #2c3e50;
  border-radius: 50%;
}
/* :checked */
input[type="checkbox"]:checked + label::before,
input[type="radio"]:checked + label::before {
  background: #fff;
  border-color: #fff;
}
input[type="checkbox"] + label::after,
input[type="radio"] + label::after {
  -webkit-transform: scale(0);
  -ms-transform: scale(0);
  -o-transform: scale(0);
  transform: scale(0);
}
input[type="checkbox"]:checked + label::after,
input[type="radio"]:checked + label::after {
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
}
/* Transition */
label::before,
label::after {
  -webkit-transition: 0.25s all ease;
  -o-transition: 0.25s all ease;
  transition: 0.25s all ease;
}
</style>